import { CSSObject } from '@emotion/css';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

// This style is shared across most of the Product Components
export const productComponentContainerPaddingStyle: CSSObject = {
  paddingTop: pxToRem(48),
  paddingLeft: pxToRem(32),
  paddingRight: pxToRem(32),

  [mqBreakpoints.tablet]: {
    paddingTop: pxToRem(64),
    paddingLeft: pxToRem(48),
    paddingRight: pxToRem(48),
  },

  [mqBreakpoints.desktop]: {
    paddingTop: pxToRem(80),
    paddingLeft: pxToRem(120),
    paddingRight: pxToRem(120),
  },
};

// Not all of the Product Components use this padding bottom i.e. The Header Component has no padding bottom
export const productComponentContainerBottomPaddingStyle: CSSObject = {
  paddingBottom: 0,

  [mqBreakpoints.tablet]: {
    paddingBottom: pxToRem(16),
  },

  [mqBreakpoints.desktop]: {
    paddingBottom: pxToRem(32),
  },
};
